import i18n from "../../../../languages/i18nextConf";

const Logic = () => {
    const lang = i18n.language;
    return { lang };
};

export default Logic;
